import { gql } from '@apollo/client'
import { useActionMutation, type UseActionResult, type UseMutationProps } from '@ztechapps/common.hook'
import { projectDocumentFragment } from './graphql'
import type { AddProjectTasksArgs, Project } from '@ztechapps/common.contract'

export const addProjectTasksQuery = gql`
  mutation addProjectTasks($input: AddProjectTasksArgs!) {
    addProjectTasks(input: $input) {
      ...projectDocumentFragment
    }
  }
  ${projectDocumentFragment}
`

export const useAddProjectTasks = (
  { query, ...props } = {} as UseMutationProps
): UseActionResult<Project, AddProjectTasksArgs> => {
  query = query ?? addProjectTasksQuery

  return useActionMutation({
    query,
    ...props,
  })
}
